<div class="custom-chip-list">
  <ng-container *ngFor="let chip of chips$ | async">
    <ng-container *ngIf="chip !== 'CUSTOM'">
      <div
        class="custom-chip"
        [class.active]="(this.selectedRange$ | async) === chip"
        (click)="enableRange(chip, $event)"
        [attr.data-cy]="
          'date-range-' +
          chip +
          '-button' +
          ((this.selectedRange$ | async) === chip ? '-selected' : '')
        ">
        {{ ("dateRangeChips." + chip | i18n) || chip }}
      </div>
    </ng-container>
    <ng-container *ngIf="chip === 'CUSTOM'">
      <div
        class="custom-chip"
        [class.active]="(this.selectedRange$ | async) === 'CUSTOM'"
        (click)="openDialog($event)"
        [attr.data-cy]="
          'date-range-CUSTOM-button' +
          ((this.selectedRange$ | async) === 'CUSTOM' ? '-selected' : '')
        ">
        {{ "dateRangeChips.CUSTOM" | i18n }}
      </div>
    </ng-container>
  </ng-container>
</div>
